import React, { useState } from "react";
import BoxKit from "../../kit/box";
import TypoGraphyKit from "../../kit/typoGraphy";

export default function UploadDocuments({
  label = "بارگذاری تصویر",
  defaultImage = "",
  onUpload,
}: {
  label: string;
  defaultImage: string;
  onUpload?: any;
}) {
  const [image, setImage] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result as string);
        onUpload?.(file);
      };
      reader.readAsDataURL(file);
    } else {
      onUpload?.(null);
    }
  };

  const handleClick = () => {
    const element = document.getElementById(label);
    if (element) {
      element.click();
    }
  };
  return (
    <BoxKit
      sx={{
        width: 250,
        height: 125,
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        bgcolor: "#29293b",
      }}
      onClick={handleClick}
    >
      <BoxKit
        component="div"
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundImage: `url(${image || defaultImage})`,
          backgroundSize: "cover",
          filter: image ? "none" : "blur(4px)",
          transition: "0.3s",
        }}
      />
      <BoxKit
        sx={{
          bgcolor: image ? "transparent" : "#29293b94",
          width: "100%",
          height: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 100,
        }}
      ></BoxKit>
      {!image ? (
        <BoxKit
          sx={{
            width: "90%",
            height: "61px",
            borderRadius: "8px",
            background: "transparent",
            border: "1px dashed #fff",
            position: "absolute",
            zIndex: 200,
          }}
        />
      ) : null}

      {!image && (
        <TypoGraphyKit
          sx={{
            color: "white",
            zIndex: 200,
            fontSize: 14,
            textAlign: "center",
            px: 1,
            lineHeight: 1.6,
            maxWidth: "200px",
          }}
        >
          {label}
        </TypoGraphyKit>
      )}

      <input
        type="file"
        id={label}
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleChange}
      />
    </BoxKit>
  );
}
